export default __webpack_public_path__ + "e12727c563de9599af1c236987ba4828.png";